document.addEventListener('DOMContentLoaded', function() {
    var sliders = document.querySelectorAll('.consultants_slider');
    
    sliders.forEach(function(slider, index) {
        var swiper = new Swiper(slider, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            autoHeight: true,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
            on: {
                init: function () {
                    updateSlideCounter(this, slider);
                },
                slideChange: function () {
                    updateSlideCounter(this, slider);
                },
            },
        });
    });

    function updateSlideCounter(swiper, slider) {
        var currentSlide = swiper.realIndex + 1;
        var totalSlides = swiper.slides.length;
        var paginationElement = slider.querySelector('.swiper-pagination-custom');
        
        if (paginationElement) {  // Verifica se l'elemento esiste
            paginationElement.innerHTML = '<strong>' + currentSlide + '</strong>' + ' / ' + totalSlides;
        }
    }
    
});
